import { jwtDecode } from 'jwt-decode';
export const parseJwtTokenClaims = (token, schema) => {
    try {
        const decodedInfo = jwtDecode(token);
        return schema.parse(decodedInfo);
    }
    catch {
        return undefined;
    }
};
